import React from 'react';
import { motion } from 'framer-motion';
export function TermsPage() {
  return <div className="min-h-screen bg-sovereign-navy text-white pt-32 pb-20" data-id="element-296">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-297">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl font-serif text-white mb-12" data-id="element-298">
          Terms of Service
        </motion.h1>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="prose prose-lg prose-invert prose-headings:font-serif prose-headings:text-white text-gray-400 font-light" data-id="element-299">
          <p data-id="element-300">
            By accessing Sovereign eTims, you agree to these terms of service.
          </p>
          <h3 data-id="element-301">Service Usage</h3>
          <p data-id="element-302">
            Our service is provided "as is" to facilitate KRA compliance. While
            we strive for 100% uptime and accuracy, the ultimate responsibility
            for tax compliance remains with the merchant.
          </p>
          <h3 data-id="element-303">Subscription</h3>
          <p data-id="element-304">
            Subscriptions are billed annually. Refunds are processed on a
            case-by-case basis within 14 days of purchase.
          </p>
          <h3 data-id="element-305">Termination</h3>
          <p data-id="element-306">
            We reserve the right to terminate service for any account found to
            be engaging in fraudulent activity or tax evasion.
          </p>
        </motion.div>
      </div>
    </div>;
}